// @flow
import React from 'react';
import _ from 'lodash';
import { EVENT_TYPES } from 'client/constants/common';
import { Icon } from '../../Icon';
import { Title } from '../Title';
import css from './Penalties.scss';

type Props = {
	title: string,
	teamsLogo: { [key: string]: string },
	penalties: any,
	homeTeam: string,
	guestTeam: string,
};

export function Penalties({ title, teamsLogo, penalties, homeTeam, guestTeam }: Props) {
	const dataByTeams = _.reduce(
		penalties,
		(acc, current, key: string) => {
			if (acc[current.Team]) {
				const arr = acc[current.Team];
				acc[current.Team] = [...arr, { ...current }];
			} else {
				acc[current.Team] = [{ ...current }];
			}
			return acc;
		},
		{}
	);

	const renderIcon = teamPenalties => {
		return (
			<div className={css.icon} key={teamPenalties.Text}>
				<Icon
					type={teamPenalties.Event === EVENT_TYPES.PENALTY_GOAL ? 'penalty-success' : 'penalty-fail'}
					className={teamPenalties.Event === EVENT_TYPES.PENALTY_GOAL ? css.iconPenalty : css.iconPenaltyFail}
				/>
			</div>
		);
	};

	return (
		<div className={css.penalties}>
			<Title title={title} className={css.title} />
			<div className={css.row}>
				<div className={css.logo}>
					<img src={teamsLogo[homeTeam]} alt="team logo" />
					<p>{homeTeam}</p>
				</div>
				{_.map(dataByTeams[homeTeam], teamPenalties => renderIcon(teamPenalties))}
				<div className={css.summ}>
					<span>=</span> 5
				</div>
			</div>
			<div className={css.row}>
				<div className={css.logo}>
					<img src={teamsLogo[guestTeam]} alt="team logo" />
					<p>{guestTeam}</p>
				</div>
				{_.map(dataByTeams[guestTeam], teamPenalties => renderIcon(teamPenalties))}
				<div className={css.summ}>
					<span>=</span> 6
				</div>
			</div>
		</div>
	);
}
